module.exports = __webpack_public_path__ + "img/01.bb5503c2.png";